import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CTAButton } from './components/CTAButton';
import { TestimonialSection } from './components/TestimonialSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { UserIcon, CheckCircleIcon, PhoneIcon, CreditCardIcon, ShieldIcon } from 'lucide-react';
export function App() {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        {/* Hero Section */}
        <div className="bg-white py-8 border-b border-gray-200" data-id="element-3">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-4">
            <h1 className="text-3xl md:text-4xl font-bold text-[#3885B2] mb-4" data-id="element-5">
              "Lekarz Mnie Zbył" - Jak Udowodniłam, Że Się Mylił
            </h1>
            <p className="text-lg text-gray-700 mb-6" data-id="element-6">
              Gdy lekarz powiedział: "To tylko menopauza, przyzwyczaj się," nie
              zgodziłam się z tym wyrokiem. Oto jak 52-letnia Ewa z Krakowa
              udowodniła, że lekarze się mylą - i schudła 8 kg bez diet czy
              hormonów.
            </p>
            <div className="flex flex-col md:flex-row gap-6 my-8" data-id="element-7">
              <div className="md:w-1/2" data-id="element-8">
                <img src="https://images.unsplash.com/photo-1442458370899-ae20e367c5d8?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Kobieta przed rozpoczęciem kuracji" className="rounded-lg shadow-md w-full aspect-square object-cover" data-id="element-9" />
              </div>
              <div className="md:w-1/2" data-id="element-10">
                <img src="https://images.unsplash.com/photo-1546961342-ea5f71b193f3?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Kobieta po kuracji ProVitalność" className="rounded-lg shadow-md w-full aspect-square object-cover" data-id="element-11" />
              </div>
            </div>
          </div>
        </div>
        {/* Story Section */}
        <div className="bg-white py-8" data-id="element-12">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-13">
            <p className="text-lg mb-6" data-id="element-14">
              Ewa Kowalska siedziała w sterylnym gabinecie lekarskim, czując się
              mniejsza niż kiedykolwiek wcześniej. Przed sobą miała listę
              symptomów, które systematycznie niszczyły jej życie od ponad roku:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-15">
              <li className="text-lg" data-id="element-16">
                12 kilogramów przyrostu wagi, głównie wokół brzucha
              </li>
              <li className="text-lg" data-id="element-17">
                Chroniczne zmęczenie, które sprawiało, że o 15:00 ledwo trzymała
                się na nogach
              </li>
              <li className="text-lg" data-id="element-18">
                Uderzenia gorąca po 8-10 razy dziennie
              </li>
              <li className="text-lg" data-id="element-19">Wzdęcia po każdym posiłku</li>
              <li className="text-lg" data-id="element-20">Bezsenność z powodu nocnych potów</li>
              <li className="text-lg" data-id="element-21">
                Huśtawki nastroju, które wpływały na jej małżeństwo
              </li>
            </ul>
            <p className="text-lg mb-6" data-id="element-22">
              Lekarz, nie podnosząc nawet wzroku znad komputera, powiedział
              słowa, które do dziś dźwięczą jej w uszach:
            </p>
            <blockquote className="border-l-4 border-[#3885B2] pl-4 italic text-lg mb-6" data-id="element-23">
              "Witamy w menopauzie. To normalne w pani wieku. Więcej ćwiczeń,
              mniej jedzenia. Może pani spróbować hormonów, ale są ryzykowne."
            </blockquote>
            <p className="text-lg mb-6" data-id="element-24">
              W tamtej chwili Ewa poczuła mieszankę gniewu i bezradności. "To
              wszystko?" - pomyślała. "Mam się pogodzić z tym, że już nigdy nie
              będę czuć się dobrze we własnym ciele?"
            </p>
            <p className="text-xl font-bold text-[#3885B2] mb-6" data-id="element-25">
              Ale Ewa postanowiła nie przyjąć tego wyroku do wiadomości...
            </p>
          </div>
        </div>
        {/* Problem Description */}
        <div className="text-center py-6 bg-white" data-id="element-26">
          <CTAButton data-id="element-27" />
        </div>
        <div className="bg-gray-50 py-8" data-id="element-28">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-29">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-30">
              Kiedy Własne Ciało Staje Się Wrogiem
            </h2>
            <p className="text-lg mb-6" data-id="element-31">
              Historia Ewy to historia tysięcy Polek po 45. roku życia. Kobiet,
              które nagle odkrywają, że ich ciało - to samo ciało, które przez
              lata służyło im wiernie - zaczyna działać przeciwko nim.
            </p>
            <p className="text-lg mb-6" data-id="element-32">
              "Czułam się jak w pułapce," wspomina Ewa. "Rano budziłam się już
              zmęczona. Patrzenie w lustro stało się torturą. Moje ulubione
              jeansy wisiały w szafie jak niemy wyrzut sumienia."
            </p>
            <p className="text-lg mb-6" data-id="element-33">
              To, co przeżywała Ewa, ma swoją nazwę w środowisku medycznym -
              zespół metaboliczny menopauzy. Ale lekarze rzadko o tym mówią.
              Zamiast tego słyszymy:
            </p>
            <ul className="list-none pl-6 mb-8 space-y-2" data-id="element-34">
              <li className="text-lg flex items-center" data-id="element-35">
                <span className="text-red-500 mr-2" data-id="element-36">✖</span> "To naturalny
                proces, trzeba się przyzwyczaić"
              </li>
              <li className="text-lg flex items-center" data-id="element-37">
                <span className="text-red-500 mr-2" data-id="element-38">✖</span> "Pani ma 50 lat,
                nie 30"
              </li>
              <li className="text-lg flex items-center" data-id="element-39">
                <span className="text-red-500 mr-2" data-id="element-40">✖</span> "Spróbuj więcej
                ćwiczyć"
              </li>
              <li className="text-lg flex items-center" data-id="element-41">
                <span className="text-red-500 mr-2" data-id="element-42">✖</span> "Może jakąś
                dietę?"
              </li>
            </ul>
            <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-43">
              <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-44">
                Desperacka Walka z Objawami
              </h3>
              <p className="text-lg mb-4" data-id="element-45">
                Jak większość kobiet w jej sytuacji, Ewa próbowała wszystkiego:
              </p>
              <div className="space-y-4" data-id="element-46">
                <div data-id="element-47">
                  <p className="font-bold" data-id="element-48">Drakońskie diety:</p>
                  <p data-id="element-49">
                    Dieta 1000 kalorii, eliminacja węglowodanów, przerywany
                    post. Rezultat? Kilka kilogramów w dół, potem efekt jo-jo i
                    jeszcze więcej frustracji.
                  </p>
                </div>
                <div data-id="element-50">
                  <p className="font-bold" data-id="element-51">Suplementy z apteki:</p>
                  <p data-id="element-52">
                    Izoflawony sojowe, czarna ciemiężyca, olej z wiesiołka.
                    Minimalny wpływ na uderzenia gorąca, zero wpływu na wagę.
                  </p>
                </div>
                <div data-id="element-53">
                  <p className="font-bold" data-id="element-54">Intensywne ćwiczenia:</p>
                  <p data-id="element-55">
                    Nordic walking trzy razy w tygodniu, aerobik dla kobiet 50+.
                    Po trzech miesiącach - żadnej zmiany na wadze, a za to
                    dodatkowe bóle kolan.
                  </p>
                </div>
                <div data-id="element-56">
                  <p className="font-bold" data-id="element-57">Herbatki odchudzające:</p>
                  <p data-id="element-58">
                    Obiecywały cuda, a dawały jedynie problemy żołądkowe i
                    odwodnienie.
                  </p>
                </div>
              </div>
            </div>
            <p className="text-lg mb-6" data-id="element-59">
              "Każda nieudana próba to była kolejna porażka," wspomina Ewa.
              "Zaczęłam wierzyć, że coś jest ze mną nie tak. Że jestem leniwa,
              że nie mam dość silnej woli."
            </p>
            <p className="text-lg mb-6" data-id="element-60">Najgorsze były komentarze otoczenia:</p>
            <ul className="list-none pl-6 mb-8 space-y-2" data-id="element-61">
              <li className="text-lg italic" data-id="element-62">"Może mniej jedz?"</li>
              <li className="text-lg italic" data-id="element-63">"W twoim wieku to normalne"</li>
              <li className="text-lg italic" data-id="element-64">
                "Moja siostra też przytyła po pięćdziesiątce"
              </li>
            </ul>
            <p className="text-lg font-bold mb-6" data-id="element-65">
              Ale czy rzeczywiście przytycie, zmęczenie i ciągłe uderzenia
              gorąca to nieunikniony element menopauzy?
            </p>
          </div>
        </div>
        {/* Discovery Section */}
        <div className="bg-white py-8" data-id="element-66">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-67">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-68">
              Odkrycie, Które Zmieniło Wszystko
            </h2>
            <p className="text-lg mb-6" data-id="element-69">
              Przełom nastąpił podczas przypadkowego spotkania. Ewa wybrała się
              na kawę ze starą koleżanką ze studiów - Anną, która po latach
              pracy w farmacji przebranżowiła się na mikrobiologię.
            </p>
            <p className="text-lg mb-6" data-id="element-70">
              Anna od razu zauważyła, jak bardzo Ewa się zmieniła.
            </p>
            <p className="text-lg mb-6" data-id="element-71">
              "Opowiedziałam jej o wszystkich moich próbach schudnięcia, o
              wizycie u lekarza, o tym jak się czuję," wspomina Ewa. "Anna
              słuchała uważnie, a potem powiedziała coś, co kompletnie mnie
              zaskoczyło."
            </p>
            <blockquote className="border-l-4 border-[#3885B2] pl-4 italic text-lg mb-8" data-id="element-72">
              "Ewa, twoje symptomy brzmią jak to, co widzimy w badaniach nad
              mikrobiomem jelitowym. A co ma twój żołądek wspólnego z menopauzą?
              Więcej niż myślisz."
            </blockquote>
            <p className="text-lg mb-6" data-id="element-73">
              Anna wyjaśniła coś, o czym żaden lekarz Ewy nigdy nie wspominał:
            </p>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-74">
              Ukryty Związek Między Jelitami a Hormonami
            </h3>
            <p className="text-lg mb-6" data-id="element-75">
              "Kiedy poziom estrogenu spada podczas menopauzy," tłumaczyła Anna,
              "nie wpływa to tylko na macicę czy jajniki. Wpływa to na cały
              organizm - w tym na bakterie w twoich jelitach."
            </p>
            <div className="flex justify-center mb-8" data-id="element-76">
              <img src="https://images.unsplash.com/photo-1579154204601-01588f351e67?q=80&w=800&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Diagram mikrobiom jelitowy" className="rounded-lg shadow-md w-full max-w-[600px] aspect-square object-cover" data-id="element-77" />
            </div>
            <p className="text-lg mb-6" data-id="element-78">
              Ewa była zaskoczona. "Bakterie? W jelitach?"
            </p>
            <p className="text-lg mb-6" data-id="element-79">
              "Tak. Masz w brzuchu triliony bakterii. Niektóre są dobre,
              niektóre złe. Estrogen pomaga utrzymać równowagę. Kiedy jego
              poziom spada, złe bakterie zaczynają dominować."
            </p>
            <p className="text-lg mb-6" data-id="element-80">
              Anna narysowała na serwetce prosty schemat:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg mb-8 text-center" data-id="element-81">
              <p className="text-lg font-bold" data-id="element-82">
                ESTROGEN SPADA → ZŁE BAKTERIE ROSNĄ → ZAPALENIE → SPOWOLNIONY
                METABOLIZM → PRZYROST WAGI
              </p>
            </div>
            <p className="text-lg mb-6" data-id="element-83">
              "To dlatego tradycyjne diety nie działają," kontynuowała Anna.
              "Walczysz z objawami, a nie z przyczyną. To jakbyś próbowała
              ugasić pożar, nie wyłączając źródła ognia."
            </p>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-84">
              Dlaczego Lekarze o Tym Nie Mówią?
            </h3>
            <p className="text-lg mb-6" data-id="element-85">
              "Medycyna wciąż traktuje menopauze jak problem ginekologiczny,"
              wyjaśniała Anna. "Ale najnowsze badania pokazują, że to problem
              całego organizmu. Jelita, hormony, metabolizm - wszystko jest
              połączone."
            </p>
            <p className="text-lg mb-6" data-id="element-86">
              Ewa czuła mieszankę ulgi i frustracji. Ulgi, bo w końcu ktoś
              wyjaśnił jej, co się dzieje. Frustracji, bo nikt wcześniej jej o
              tym nie powiedział.
            </p>
            <p className="text-lg mb-6" data-id="element-87">"Czyli to nie moja wina?" zapytała.</p>
            <p className="text-lg mb-6" data-id="element-88">
              "Absolutnie nie. Twój organizm zmienił się na poziomie
              biochemicznym. Potrzebujesz podejścia, które to uwzględnia."
            </p>
          </div>
        </div>
        {/* Solution Section */}
        <div className="text-center py-6 bg-white" data-id="element-89">
          <CTAButton data-id="element-90" />
        </div>
        <div className="bg-gray-50 py-8" data-id="element-91">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-92">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-93">
              Rozwiązanie, Którego Szukała
            </h2>
            <p className="text-lg mb-6" data-id="element-94">
              Anna nie była tylko przyjaciółką - była badaczką, która przez
              ostatnie lata studiowała wpływ mikrobioty jelitowej na zdrowie
              kobiet w wieku średnim.
            </p>
            <p className="text-lg mb-6" data-id="element-95">
              "Pokazała mi badania, które robiła na uniwersytecie," wspomina
              Ewa. "Konkretne szczepy bakterii, które pomagają kobietom w
              menopauzie. To nie były żadne ogólne probiotyki z apteki."
            </p>
            <p className="text-lg mb-6" data-id="element-96">
              Anna wyjaśniła, czego potrzebuje organizm Ewy:
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-97">
              <ul className="space-y-4" data-id="element-98">
                <li data-id="element-99">
                  <p className="font-bold text-[#3885B2]" data-id="element-100">L. gasseri SBT2055</p>
                  <p data-id="element-101">
                    Szczep probiotyczny klinicznie badany pod kątem redukcji
                    tłuszczu brzusznego. W 12-tygodniowym badaniu kobiety
                    straciła średnio 4,6% tkanki tłuszczowej z okolic brzucha.
                  </p>
                </li>
                <li data-id="element-102">
                  <p className="font-bold text-[#3885B2]" data-id="element-103">B. breve IDCC04401</p>
                  <p data-id="element-104">
                    Pomaga utrzymać prawidłową wrażliwość na insulinę, co jest
                    kluczowe dla kontroli wagi w menopauzie.
                  </p>
                </li>
                <li data-id="element-105">
                  <p className="font-bold text-[#3885B2]" data-id="element-106">B. lactis R101-8</p>
                  <p data-id="element-107">
                    Wspiera równowagę mikrobioty jelitowej i poprawia trawienie.
                  </p>
                </li>
                <li data-id="element-108">
                  <p className="font-bold text-[#3885B2]" data-id="element-109">
                    Kurkuma (95% kurkuminoidów)
                  </p>
                  <p data-id="element-110">
                    Naturlany przeciwzapalny składnik, który redukuje przewlekłe
                    zapalenie wywołane menopauzą.
                  </p>
                </li>
                <li data-id="element-111">
                  <p className="font-bold text-[#3885B2]" data-id="element-112">Liść moringi</p>
                  <p data-id="element-113">
                    Bogaty w witaminy i minerały, wspiera energię i nastrój.
                  </p>
                </li>
                <li data-id="element-114">
                  <p className="font-bold text-[#3885B2]" data-id="element-115">Liść curry</p>
                  <p data-id="element-116">
                    Pomaga regulować poziom cukru we krwi i zmniejsza ochotę na
                    słodycze.
                  </p>
                </li>
              </ul>
            </div>
            <p className="text-lg mb-6" data-id="element-117">
              "To nie jest kolejny suplement," podkreśliła Anna. "To dokładnie
              skomponowana formuła, która atakuje problem z kilku stron
              jednocześnie."
            </p>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-118">
              Początkowa Nieufność
            </h3>
            <p className="text-lg mb-6" data-id="element-119">Ewa przyznaje, że była sceptyczna:</p>
            <p className="text-lg mb-6" data-id="element-120">
              "Po tylu porażkach, każda nowa obietnica brzmiała jak kolejne
              oszustwo. Ale Anna pokazała mi konkretne badania, publikacje
              naukowe. To nie były marketingowe gadki."
            </p>
            <p className="text-lg mb-6" data-id="element-121">Co przekonało Ewę ostatecznie?</p>
            <p className="text-lg mb-6" data-id="element-122">
              "Po pierwsze, to miało sens naukowy. Po drugie, było naturalne -
              żadnych hormonów czy chemii. Po trzecie, Anna była moją
              przyjaciółką, nie sprzedawcą."
            </p>
          </div>
        </div>
        {/* Results Section */}
        <div className="bg-white py-8" data-id="element-123">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-124">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-125">
              Transformacja: Dzień Po Dniu
            </h2>
            <div className="space-y-8" data-id="element-126">
              <div data-id="element-127">
                <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-128">
                  Tygodnie 1-2: Pierwsze Oznaki
                </h3>
                <p className="text-lg mb-4" data-id="element-129">
                  "Pierwsze, co zauważyłam, to sen," wspomina Ewa. "Przestałam
                  budzić się w nocy oblana potem. To była ulga nie do opisania."
                </p>
                <p className="text-lg mb-4" data-id="element-130">Inne subtelne zmiany:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-131">
                  <li className="text-lg" data-id="element-132">Mniej wzdęć po posiłkach</li>
                  <li className="text-lg" data-id="element-133">Brak tradycyjnego "dołka" o 15:00</li>
                  <li className="text-lg" data-id="element-134">Lepsza kondycja psychiczna rano</li>
                </ul>
                <p className="text-lg mb-4" data-id="element-135">
                  "Nie byłam pewna, czy to rzeczywiste zmiany, czy efekt
                  placebo. Ale mój mąż zauważył, że jestem mniej drażliwa."
                </p>
              </div>
              <div data-id="element-136">
                <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-137">
                  Tygodnie 3-6: Nabieranie Rozpędu
                </h3>
                <p className="text-lg mb-4" data-id="element-138">
                  W piątym tygodniu Ewa zauważyła, że jej ulubiona bluzka wydaje
                  się luźniejsza wokół talii.
                </p>
                <p className="text-lg mb-4" data-id="element-139">
                  "Stanęłam na wadze pierwszy raz od miesiąca. 3 kilogramy w
                  dół! Bez diety, bez głodówki, bez dręczenia się w siłowni."
                </p>
                <p className="text-lg mb-4" data-id="element-140">Inne zmiany:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-141">
                  <li className="text-lg" data-id="element-142">
                    Uderzenia gorąca zmniejszyły się z 8-10 dziennie do 3-4
                  </li>
                  <li className="text-lg" data-id="element-143">Energia zostaje do wieczora</li>
                  <li className="text-lg" data-id="element-144">Nastrój bardziej stabilny</li>
                  <li className="text-lg" data-id="element-145">
                    Pierwsze komentarze rodziny: "Wyglądasz lepiej"
                  </li>
                </ul>
              </div>
              <div data-id="element-146">
                <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-147">
                  Tygodnie 7-12: Pełna Przemiana
                </h3>
                <p className="text-lg mb-4" data-id="element-148">
                  Do końca trzeciego miesiąca Ewa była już zupełnie inną osobą:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-149">
                  <div className="bg-gray-50 p-4 rounded-lg" data-id="element-150">
                    <p className="font-bold" data-id="element-151">Waga:</p>
                    <p data-id="element-152">Minus 8 kilogramów bez jednej diety</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg" data-id="element-153">
                    <p className="font-bold" data-id="element-154">Obwód talii:</p>
                    <p data-id="element-155">Minus 12 centymetrów</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg" data-id="element-156">
                    <p className="font-bold" data-id="element-157">Uderzenia gorąca:</p>
                    <p data-id="element-158">1-2 razy w tygodniu zamiast dziennie</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg" data-id="element-159">
                    <p className="font-bold" data-id="element-160">Energia:</p>
                    <p data-id="element-161">Jak w wieku 40 lat</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg" data-id="element-162">
                    <p className="font-bold" data-id="element-163">Bóle stawów:</p>
                    <p data-id="element-164">Całkowicie ustąpiły</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg" data-id="element-165">
                    <p className="font-bold" data-id="element-166">Nastrój:</p>
                    <p data-id="element-167">Stała radość życia</p>
                  </div>
                </div>
                <p className="text-lg mb-4" data-id="element-168">
                  "Moment przełomowy nastąpił, gdy założyłam jeansy sprzed
                  trzech lat. Nie tylko się załapały - były luźne! Płakałam ze
                  szczęścia."
                </p>
              </div>
            </div>
            <BeforeAfterSection data-id="element-169" />
          </div>
        </div>
        {/* Science Section */}
        <div className="bg-gray-50 py-8" data-id="element-170">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-171">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-172">
              Nauka Stoi Za Tym, Co Przeżyła Ewa
            </h2>
            <p className="text-lg mb-6" data-id="element-173">
              Historia Ewy brzmi jak cud, ale ma solidne podstawy naukowe.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-174">
              <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-175">
                Mechanizm Działania
              </h3>
              <div className="space-y-4" data-id="element-176">
                <div data-id="element-177">
                  <p className="font-bold" data-id="element-178">
                    Krok 1: Przywrócenie Równowagi Bakteryjnej
                  </p>
                  <p data-id="element-179">
                    Specjalne szczepy probiotyków wypierają patogenne bakterie i
                    przywracają zdrową florę jelitową.
                  </p>
                </div>
                <div data-id="element-180">
                  <p className="font-bold" data-id="element-181">Krok 2: Redukcja Zapalenia</p>
                  <p data-id="element-182">
                    Kurkuma i inne składniki redukują przewlekłe zapalenie,
                    które nasila się w menopauzie.
                  </p>
                </div>
                <div data-id="element-183">
                  <p className="font-bold" data-id="element-184">Krok 3: Poprawa Metabolizmu</p>
                  <p data-id="element-185">
                    Zdrowe jelita lepiej metabolizują hormony i składniki
                    odżywcze, przyspieszając spalanie.
                  </p>
                </div>
                <div data-id="element-186">
                  <p className="font-bold" data-id="element-187">Krok 4: Stabilizacja Nastroju</p>
                  <p data-id="element-188">
                    90% serotoniny produkowane jest w jelitach. Zdrowy mikrobiom
                    = lepszy nastrój.
                  </p>
                </div>
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-189">
              Dowody Naukowe
            </h3>
            <div className="space-y-4 mb-8" data-id="element-190">
              <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-191">
                <p className="font-bold" data-id="element-192">Badanie L. gasseri (2013):</p>
                <p data-id="element-193">
                  87 kobiet z nadwagą przyjmowało L. gasseri przez 12 tygodni.
                  Średnia redukcja tłuszczu brzusznego: 4,6%.
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-194">
                <p className="font-bold" data-id="element-195">Badania kurkuminy (2019):</p>
                <p data-id="element-196">
                  Suplementacja kurkuminą przez 8 tygodni zredukowała markery
                  zapalenia o 25-30% u kobiet po menopauzie.
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-197">
                <p className="font-bold" data-id="element-198">Meta-analiza probiotyków (2021):</p>
                <p data-id="element-199">
                  Przegląd 15 badań potwierdził skuteczność specyficznych
                  szczepów w redukcji wagi u kobiet po 45. roku życia.
                </p>
              </div>
            </div>
            <div className="flex justify-center mb-8" data-id="element-200">
              <img src="https://images.unsplash.com/photo-1582719471384-894fbb16e074?q=80&w=800&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Diagram naukowy mikrobiom" className="rounded-lg shadow-md w-full max-w-[600px] aspect-square object-cover" data-id="element-201" />
            </div>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-202">
              Dlaczego To Działa, Gdy Inne Metody Zawodzą
            </h3>
            <p className="text-lg mb-6" data-id="element-203">
              "Tradycyjne podejście traktuje objawy osobno," wyjaśnia Anna.
              "Dieta na wagę, leki na uderzenia gorąca, tabletki na nastrój. To
              jak próba naprawy samochodu wymieniając tylko opony."
            </p>
            <p className="text-lg mb-6" data-id="element-204">
              "Nasze podejście jest holistyczne. Naprawiamy silnik - jelita i
              mikrobiom - a cały organizm zaczyna działać lepiej."
            </p>
          </div>
        </div>
        {/* Testimonials Section */}
        <TestimonialSection data-id="element-205" />
        {/* Product Section */}
        <div className="bg-white py-8" data-id="element-206">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-207">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-208">
              ProVitalność - Ta Sama Formuła, Która Pomogła Ewie
            </h2>
            <p className="text-lg mb-6" data-id="element-209">
              Po sukcesie Ewy, Anna postanowiła udostępnić swoją formułę innym
              polskim kobietom. Tak powstała ProVitalność - pierwszy suplement w
              Polsce zaprojektowany specjalnie dla kobiet w menopauzie, który
              atakuje problem u źródła.
            </p>
            <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-210">
              <div className="md:w-1/2" data-id="element-211">
                <img src="https://images.unsplash.com/photo-1550572017-edd951b55104?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="ProVitalność Suplement" className="rounded-lg shadow-md w-full aspect-square object-cover" data-id="element-212" />
              </div>
              <div className="md:w-1/2" data-id="element-213">
                <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-214">
                  Dokładnie Te Same Składniki:
                </h3>
                <div className="space-y-4" data-id="element-215">
                  <div data-id="element-216">
                    <p className="font-bold" data-id="element-217">
                      3 Kluczowe Szczepy Probiotyczne:
                    </p>
                    <ul className="list-disc pl-6 space-y-1" data-id="element-218">
                      <li data-id="element-219">L. gasseri SBT2055 - 15 miliardów CFU</li>
                      <li data-id="element-220">B. breve IDCC04401 - 10 miliardów CFU</li>
                      <li data-id="element-221">B. lactis R101-8 - 15 miliardów CFU</li>
                    </ul>
                  </div>
                  <div data-id="element-222">
                    <p className="font-bold" data-id="element-223">Wsparcie Ziołowe:</p>
                    <ul className="list-disc pl-6 space-y-1" data-id="element-224">
                      <li data-id="element-225">
                        Kurkuma (95% kurkuminoidów) - 500mg z BioPerine® dla
                        lepszej absorpcji
                      </li>
                      <li data-id="element-226">Liść moringi - 300mg witamin i minerałów</li>
                      <li data-id="element-227">Liść curry - 200mg do kontroli poziomu cukru</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-228">
              Dlaczego ProVitalność Jest Inna?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-229">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-230">
                <p className="font-bold" data-id="element-231">1. Celowana Formuła:</p>
                <p data-id="element-232">
                  To nie jest ogólny probiotyk. Każdy składnik został wybrany
                  specjalnie dla kobiet w menopauzie.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-233">
                <p className="font-bold" data-id="element-234">2. Dawkowanie Terapeutyczne:</p>
                <p data-id="element-235">
                  Nie symboliczne ilości, ale dawki potwierdzone w badaniach
                  klinicznych.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-236">
                <p className="font-bold" data-id="element-237">3. Zaawansowana Technologia:</p>
                <p data-id="element-238">
                  Kapsułki DRcaps™ chronią probiotyki przed kwasem żołądkowym,
                  zapewniając że dotarą żywe do jelit.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-239">
                <p className="font-bold" data-id="element-240">4. Synergiczne Działanie:</p>
                <p data-id="element-241">
                  Składniki wzmacniają się wzajemnie, dając efekt większy niż
                  suma części.
                </p>
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-242">
              Prosta Rutyna
            </h3>
            <p className="text-lg mb-8" data-id="element-243">
              Tak jak u Ewy - 2 kapsułki rano z poranną kawą. Żadnych
              skomplikowanych schematów, żadnych drastycznych zmian stylu życia.
            </p>
            <blockquote className="border-l-4 border-[#3885B2] pl-4 italic text-lg mb-8" data-id="element-244">
              "Najpiękniejsze w tym rozwiązaniu jest to, że jest proste," mówi
              Ewa. "Nie musisz zmieniać całego życia. Po prostu dajesz swojemu
              organizmowi to, czego potrzebuje."
            </blockquote>
          </div>
        </div>
        {/* FAQ Section */}
        <div className="bg-gray-50 py-8" data-id="element-245">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-246">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3885B2] mb-6" data-id="element-247">
              Czy To Rozwiązanie Jest Dla Ciebie?
            </h2>
            <div className="space-y-8" data-id="element-248">
              <div data-id="element-249">
                <h3 className="text-xl font-bold mb-4" data-id="element-250">
                  "Próbowałam Już Probiotyki i Nie Działały"
                </h3>
                <p className="text-lg mb-4" data-id="element-251">
                  "Rozumiem twoją frustrację," mówi Anna. "Ale prawda jest taka,
                  że 90% probiotyków na rynku to ogólne formuły bez konkretnego
                  celu. To jak próba naprawy samochodu uniwersalnym kluczem."
                </p>
                <p className="text-lg mb-4" data-id="element-252">ProVitalność to:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-253">
                  <li className="text-lg" data-id="element-254">
                    Szczepy wybrane specjalnie dla menopauzy
                  </li>
                  <li className="text-lg" data-id="element-255">
                    Dawki terapeutyczne, nie symboliczne
                  </li>
                  <li className="text-lg" data-id="element-256">Ochrona przed kwasem żołądkowym</li>
                  <li className="text-lg" data-id="element-257">
                    Składniki synergiczne wzmacniające działanie
                  </li>
                </ul>
              </div>
              <div data-id="element-258">
                <h3 className="text-xl font-bold mb-4" data-id="element-259">
                  "Jestem Sceptyczna Wobec Suplementów"
                </h3>
                <p className="text-lg mb-4" data-id="element-260">Ewa też była:</p>
                <p className="text-lg mb-4" data-id="element-261">
                  "Po tylu rozczarowaniach, każda obietnica brzmiała jak
                  oszustwo. Ale tutaj miałam do czynienia z badaniami, nie z
                  marketingiem. Anna pokazała mi konkretne publikacje naukowe."
                </p>
                <p className="text-lg mb-4" data-id="element-262">Fakty o ProVitalność:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-263">
                  <li className="text-lg" data-id="element-264">
                    Składniki backed by peer-reviewed research
                  </li>
                  <li className="text-lg" data-id="element-265">
                    94,4% kobiet doświadcza poprawy w ciągu 90 dni
                  </li>
                  <li className="text-lg" data-id="element-266">
                    Produkowane w certyfikowanym zakładzie zgodnie z normami EU
                  </li>
                  <li className="text-lg" data-id="element-267">
                    Żadnych syntetycznych hormonów czy szkodliwych chemikaliów
                  </li>
                </ul>
              </div>
              <div data-id="element-268">
                <h3 className="text-xl font-bold mb-4" data-id="element-269">
                  "A Co z Skutkami Ubocznymi?"
                </h3>
                <p className="text-lg mb-4" data-id="element-270">
                  "To był jeden z moich największych strachów," przyznaje Ewa.
                  "Ale to są naturalne składniki, które organizm rozpoznaje i
                  akceptuje."
                </p>
                <p className="text-lg mb-4" data-id="element-271">Profil bezpieczeństwa:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-272">
                  <li className="text-lg" data-id="element-273">
                    Naturalne składniki pochodzenia roślinnego
                  </li>
                  <li className="text-lg" data-id="element-274">
                    Szczepy probiotyczne bezpieczne dla człowieka
                  </li>
                  <li className="text-lg" data-id="element-275">
                    Brak raportowanych skutków ubocznych w badaniach klinicznych
                  </li>
                  <li className="text-lg" data-id="element-276">
                    Działa z naturalnymi procesami organizmu, nie przeciwko nim
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="bg-white py-8" data-id="element-277">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-278">
            <div className="bg-[#3885B2] text-white p-8 rounded-lg shadow-lg" data-id="element-279">
              <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center" data-id="element-280">
                Nie czekaj. Twoja przemiana może zacząć się już dziś.
              </h2>
              <div className="text-center mb-8" data-id="element-281">
                <p className="text-xl font-bold mb-2" data-id="element-282">Ograniczona Dostępność</p>
                <p className="text-lg mb-4" data-id="element-283">
                  Obecny zapas: 743/800 butelek pozostało
                </p>
                <div className="w-full bg-white rounded-full h-4 mb-4" data-id="element-284">
                  <div className="bg-green-500 h-4 rounded-full" style={{
                  width: '92%'
                }} data-id="element-285"></div>
                </div>
              </div>
              <div className="flex flex-col items-center" data-id="element-286">
                <CTAButton data-id="element-287" />
                <div className="flex flex-wrap justify-center gap-4 mt-6" data-id="element-288">
                  <div className="flex items-center" data-id="element-289">
                    <CheckCircleIcon className="w-5 h-5 mr-2" data-id="element-290" />
                    <span data-id="element-291">30-dniowa gwarancja zwrotu pieniędzy</span>
                  </div>
                  <div className="flex items-center" data-id="element-292">
                    <CheckCircleIcon className="w-5 h-5 mr-2" data-id="element-293" />
                    <span data-id="element-294">Darmowa dostawa w Polsce</span>
                  </div>
                  <div className="flex items-center" data-id="element-295">
                    <CheckCircleIcon className="w-5 h-5 mr-2" data-id="element-296" />
                    <span data-id="element-297">Dyskretne opakowanie</span>
                  </div>
                </div>
                <div className="flex flex-wrap justify-center gap-4 mt-4" data-id="element-298">
                  <div className="flex items-center" data-id="element-299">
                    <UserIcon className="w-5 h-5 mr-2" data-id="element-300" />
                    <span data-id="element-301">Polski serwis kliencki</span>
                  </div>
                  <div className="flex items-center" data-id="element-302">
                    <ShieldIcon className="w-5 h-5 mr-2" data-id="element-303" />
                    <span data-id="element-304">Bezpieczne płatności</span>
                  </div>
                </div>
                <div className="mt-6" data-id="element-305">
                  <p className="font-bold mb-2" data-id="element-306">Dostępne Metody Płatności:</p>
                  <div className="flex flex-wrap justify-center gap-4" data-id="element-307">
                    <div className="flex items-center" data-id="element-308">
                      <CreditCardIcon className="w-5 h-5 mr-1" data-id="element-309" />
                      <span data-id="element-310">Visa/Mastercard</span>
                    </div>
                    <div className="flex items-center" data-id="element-311">
                      <span className="font-bold mr-1" data-id="element-312">BLIK</span>
                    </div>
                    <div className="flex items-center" data-id="element-313">
                      <span data-id="element-314">Przelewy24</span>
                    </div>
                    <div className="flex items-center" data-id="element-315">
                      <PhoneIcon className="w-5 h-5 mr-1" data-id="element-316" />
                      <span data-id="element-317">Płatność przy odbiorze</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Final Quote */}
        <div className="bg-gray-50 py-8" data-id="element-318">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-319">
            <blockquote className="border-l-4 border-[#3885B2] pl-6 italic text-lg mb-8" data-id="element-320">
              <p className="mb-4" data-id="element-321">
                "Jeśli czytasz ten tekst i myślisz 'to brzmi jak moja historia'
                - nie jesteś sama. Przez lata czułam się jak więzień własnego
                ciała. Lekarze mówili mi, że tak już będzie. Że mam się pogodzić
                z tym, że najlepsze lata mam za sobą."
              </p>
              <p className="mb-4" data-id="element-322">
                "Dziś wiem, że to nieprawda. Mam 54 lata i czuję się lepiej niż
                w wieku 45. Mam energię, radość życia, pasję. Mój związek z
                mężem rozkwitł na nowo. Znów lubię swoje odbicie w lustrze."
              </p>
              <p className="mb-4" data-id="element-323">
                "Nie musisz się pogodzić z 'to tylko menopauza.' Nie musisz
                akceptować, że twoje najlepsze lata minęły. Możesz odzyskać
                siebie - prawdziwą siebie."
              </p>
              <p data-id="element-324">
                "Pierwszy krok to najtrudniejszy. Ale gdy go zrobisz, wszystko
                się zmienia. Twoja przemiana może zacząć się już dziś."
              </p>
            </blockquote>
            <div className="text-center" data-id="element-325">
              <CTAButton data-id="element-326" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-327" />
    </div>;
}